/**
 * Site desenvolvido para divulgação das especializações de odontologia
 *
 * @version 1.0.0
 * @author [Renato Alves](https://github.com/renatociqueira)
 */

import React from "react";
import './Footer.css';

const Footer = () => {
    return(
        <footer className="rodape">
            <p align="center">©2021 Unifacex - Desenvolvido pelo departamento de TI e MARKETING</p>
        </footer>
    )
}

export default Footer;